<template>
    <div class="sidebar-detail">
        <!-- :title="`${detailInfo.name || '----' } ${qrCode}`" -->
        <detail-header
            v-if="detailInfo"
            title="Pollen Bottle"
            @refreshDetailPage="refreshDetailPage"
            @closeDetailPage="closeDetailPage"
        />

        <div v-if="detailInfo">
            <p class="detail-title">Details</p>
            <div>
                <table class="recording-detail-table">
                    <tr>
                        <td>Id</td>
                        <td>{{ detailInfo.id }}</td>
                    </tr>
                    <tr>
                        <td>QR Code</td>
                        <td>{{ qrCode }}</td>
                    </tr>
                    <tr>
                        <td>Pollen</td>
                        <td>{{ pollenQrCode }}</td>
                    </tr>
                    <tr>
                        <td>Palm</td>
                        <td>
                            <mpob-palm-format :cell="(detailInfo.pollen||{}).palm" /> 
                        </td>
                    </tr>
                    <tr>
                        <td>Serial No</td>
                        <td>{{ detailInfo.serialNo || "-" }}</td>
                    </tr>

                    <tr>
                        <td class="table-section" colspan="2">Amount</td>
                    </tr>
                    <tr>
                        <td>Total Received</td>
                        <td>{{ detailInfo.totalReceiveAmount || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Total Distributed</td>
                        <td>{{ detailInfo.totalDistributeAmount || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Total Pollinated</td>
                        <td>{{ detailInfo.totalPollinateAmount || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Total Discarded</td>
                        <td>{{ detailInfo.totalDiscardAmount || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Balance</td>
                        <td>{{ detailInfo.currentAmount || "-" }}</td>
                    </tr>
                </table>
            </div>

            <p class="detail-title detail-title-pd">Pollen Bottle Viability Test</p>
            <pollen-lab-quality-control-simple-table ref="labQC" :pollen-bottle-id="detailInfo.id" />

            <p class="detail-title detail-title-pd">Date Time</p>
            <div class="user-datetime-container">
                <table>
                    <tr>
                        <td>Modified</td>
                        <td>{{ $_getDateTimeFormat(detailInfo.lastModificationTime) }} {{ $t('detail.by') }} {{ (detailInfo.lastModifierUser||{}).userName || '-' }}</td>
                    </tr>
                    <tr>
                        <td>Created</td>
                        <td>{{ $_getDateTimeFormat(detailInfo.creationTime) }} {{ $t('detail.by') }} {{ (detailInfo.creatorUser||{}).userName || '-' }}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import DetailHeader from "./DetailHeader";
import { pollenBottleGet } from "@/api/pollen_bottle";
import MPOBPalmFormat from "@/components/Progeny/MPOBPalmFormat";
import PollenLabQualityControlSimpleTable from "@/components/PollenBottle/PollenLabQualityControlSimpleTable";

export default {
    components: {
        "detail-header": DetailHeader,
        "mpob-palm-format": MPOBPalmFormat,
        "pollen-lab-quality-control-simple-table": PollenLabQualityControlSimpleTable,
    },
    props: {
        infoSidebarId: {
            type: Number | String
        }
    },
    data() {
        return {
            detailInfo: null
        };
    },
    computed: {
        qrCode() {
            return this.detailInfo.qrCode ? `${this.detailInfo?.qrCode?.code}` : "";
        },
        pollenQrCode() {
            return this.detailInfo?.pollen?.qrCode?.code || "-";
        }
    },
    watch: {
        infoSidebarId: {
            immediate: true,
            handler() {
                this.getDetails();
            },
        }
    },
    methods: {
        async getDetails() {
            if (this.infoSidebarId) {
                var res = await pollenBottleGet({ Id: this.infoSidebarId });
                if (res) {
                    this.detailInfo = res;
                }
            }
        },
        refreshDetailPage() {
            this.getDetails();
            if (this.$refs["labQC"]) {
                this.$refs["labQC"].getPollenBottles();
            }
        },
        closeDetailPage() {
            this.$store.dispatch("info_sidebar/setInfoSidebar");
        }
    },
};
</script>

<style scoped>
.stepper-container {
    padding: var(--space-16) 0;
}
</style>


// WEBPACK FOOTER //
// src/components/SidebarDetail/PollenBottleSidebar.vue